<div class="container">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-toast></aw-toast>
  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'Customer Management'"
    [altColor]="false"
  >
  </aw-divider>

  <div class="table-form-container" [ngClass]="container_theme()">
    <div>
      <aw-search
        [(ngModel)]="searchInputValue"
        (ngModelChange)="onSearchInput(searchInputValue)"
        [placeholder]="'Search'"
        ariaLabel="search-menu"
        [searchOptions]="selectionOptions"
      >
        <mat-icon [svgIcon]="'search'" position="prefix"></mat-icon>
      </aw-search>
    </div>

    <app-aw-dropdown-form
      [required]="false"
      [options]="statusOptions()"
      title="Status"
      (currentOption)="onCustomerStatusSelected($event)"
    ></app-aw-dropdown-form>

    @if (userPermissions['canEdit']) {
    <Button
      AwButton
      [disable]="disableChangeStatus"
      (click)="openChangeStatusDialog = true"
      >Change Status</Button
    >
    }
  </div>

  <aw-dialog
    [visible]="openChangeStatusDialog"
    [formFieldsData]="formFieldsData()"
    [dialogOptions]="dialogOptionsStatus()"
    (primaryAction)="dialogFormValuesHandler($event, 'status')"
    (secondaryAction)="dialogCloseHandler('status')"
    ariaLabel="Change customer status"
  >
  </aw-dialog>

  <aw-dialog
    [visible]="openDeleteCustomerDialog"
    [dialogOptions]="dialogOptionsDelete"
    (primaryAction)="dialogFormValuesHandler($event, 'delete')"
    (secondaryAction)="dialogCloseHandler('delete')"
    ariaLabel="Delete customer"
  >
  </aw-dialog>

  <aw-table
    [columnsDefinition]="columnsDefinition"
    [tableData]="tableData()"
    [enableStickyOptions]="enableStickyOptions()"
    [sortDisabled]="sortDisabled()"
    (checkboxList)="checkBoxActionHandler($event)"
  >
  </aw-table>
</div>

@if (userPermissions['canCreate']) {
<div class="footer-container">
  <aw-action-bar [actionsRight]="actionsRight()"> </aw-action-bar>
</div>
}
